import * as React from 'react';
import { useState } from 'react';
import GenericEditor from './GenericEditor';
import { ApplicationSubmissionEditorFields, ApplicationSubmissionTab } from '../editorFields/ApplicationSubmissionEditorFields';
import { UserProfile, ValidationSchema } from '../../models/UserProfile';
import UserProfileService from '../../services/UserProfileService';
import { FormikProps, FormikValues } from 'formik';


export const ApplicationSubmissionEditor = (props: { mode: 'apply' | 'view' }) => {

    // Lifted so the Save/Discard buttons (rendered by GenericEditor) can be shown only on the Profile and Review tabs.
    const [activeTab, setActiveTab] = useState<ApplicationSubmissionTab>('dashboard');

    return <>
        <GenericEditor<UserProfile, string>
            getById={id =>
                props.mode == 'apply'
                    ? UserProfileService.getNewApplicationSubmission()
                    : UserProfileService.getApplicationSubmissionById(id)
            }
            save={model => UserProfileService.saveApplicationSubmission(model)}
            formikFields={(formikState: FormikProps<FormikValues>) =>
                <ApplicationSubmissionEditorFields
                    {...formikState}
                    activeTab={activeTab}
                    onActiveTabChange={setActiveTab}
                />
            }
            validationSchema={ValidationSchema}
            stringToId={x => x}
            getId={x => x.userProfileId}
            shouldTryToLoad={id => true}
            allowSaveOnClean={true}
            disableSaveButton={activeTab !== 'data' && activeTab !== 'review'}
        />
    </>
}